import React, { ReactElement, useCallback, useMemo, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import BaseModal from "src/components/modals/base-modal";
import Content from "src/components/modals/confirmation-modal/content";
import { IConfirmContentProps } from "src/components/interfaces";
import { IService } from "src/pages/projects/project/interfaces";
import style from "../../pages/projects/project/styles";
import DeleteButton from "../control-buttons/delete-button";
import DuplicateButton from "../control-buttons/duplicate-button/DuplicateButton";

interface IProps {
  service: IService;
  onDuplicateTerm: () => void;
  onDeleteClick: () => void;
}
const CollapsibleHeaderDeleteAndDuplicate = ({
  service,
  onDuplicateTerm,
  onDeleteClick,
}: IProps): ReactElement => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOnCloseModalClick = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleConfirmDeleteClick = useCallback(() => {
    onDeleteClick();
    setIsModalOpen(false);
  }, [onDeleteClick]);

  const handleDuplicateClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.stopPropagation();
      onDuplicateTerm();
    },
    [onDuplicateTerm]
  );

  const handleDeleteClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.stopPropagation();
      setIsModalOpen(true);
    },
    []
  );

  const confirmDeleteContentProps = useMemo(() => {
    return {
      confirmAction: handleConfirmDeleteClick,
      onClose: handleOnCloseModalClick,
      primaryButtonLabel: t("Delete"),
      secondaryButtonLabel: t("Cancel"),
      mainContent: (
        <p data-testid="confirmation-content">
          <Trans i18nKey="ProjectsPage##servicesSection##Are you sure?">
            {{ serviceName: service.asset?.name }}
          </Trans>
        </p>
      ),
    };
  }, [
    handleConfirmDeleteClick,
    handleOnCloseModalClick,
    service.asset?.name,
    t,
  ]);

  return (
    <div css={style.switchContainer}>
      <div css={style.addIconContainer}>
        <DuplicateButton onClick={handleDuplicateClick} />
      </div>
      <DeleteButton onClick={handleDeleteClick} />
      <BaseModal
        open={isModalOpen}
        content={<Content {...confirmDeleteContentProps} />}
        buttons={[]}
        onClose={handleOnCloseModalClick}
        onCancel={handleOnCloseModalClick}
      />
    </div>
  );
};

export default CollapsibleHeaderDeleteAndDuplicate;
